export default __webpack_public_path__ + "static/media/EG.122083da.svg";